module.exports = __webpack_public_path__ + "static/media/MedicaidActive.be44cda3.svg";